import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendTag } from '../../../projects/preview/components/trend-tag/TrendTag';
import { GroupInsights } from '../../models/AgencyStatsDerived';

interface AgencyStatsInsightTilesProps {
  insights: GroupInsights;
}

const AgencyStatsInsightTiles: React.FC<AgencyStatsInsightTilesProps> = ({ insights }) => {
  const { t } = useTranslation();

  return (
    <>
    <div className="page-box__title-action">
      <div className="page-box__title page-box__title--flex">{t('agencyStatsInsightsTitle')}</div>
    </div>
    <div className="agency-stats-insights">
      <div className="agency-stats-insights__tile">
        <div className="agency-stats-insights__label">{t('agencyStatsHighestUsage')}</div>
        <div className="agency-stats-insights__value">
          {insights.highestUsage?.groupName ?? '-'}
        </div>
        {insights.highestUsage && (
          <div className="agency-stats-insights__detail">
            {insights.highestUsage.totalPrompts} {t('agencyStatsPrompts').toLowerCase()}
          </div>
        )}
      </div>
      <div className="agency-stats-insights__tile">
        <div className="agency-stats-insights__label">{t('agencyStatsFastestGrowing')}</div>
        <div className="agency-stats-insights__value">
          {insights.fastestGrowing?.group.groupName ?? '-'}
          {insights.fastestGrowing && (
            <TrendTag trendValue={insights.fastestGrowing.deltaPercent} suffix="%" />
          )}
        </div>
      </div>
      <div className="agency-stats-insights__tile">
        <div className="agency-stats-insights__label">{t('agencyStatsLowestActivity')}</div>
        <div className="agency-stats-insights__value">
          {insights.lowestActivity?.groupName ?? '-'}
        </div>
        {insights.lowestActivity && (
          <div className="agency-stats-insights__detail">
            {insights.lowestActivity.activePrompts} {t('agencyStatsActive').toLowerCase()}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default AgencyStatsInsightTiles;
